import {
  claimsLogo,
  designLogo,
  engineeringLogo,
  financeAndAccountingLogo,
  marketingLogo,
  operationsLogo,
  peopleOpsHrLogo,
  productLogo,
  salesAndUnderwritingLogo,
  customerSuccess,
  underwritingLogo,
} from '@prishapolicy/w3/assets';
import { BasicCard } from '@prishapolicy/w3/ui';
import useWindowWidth from 'libs/shared/ui/src/lib/useWindowWidth';

const teams = [
  [
    {
      name: 'Marketing',
      logo: marketingLogo,
    },
    {
      name: 'Sales',
      logo: salesAndUnderwritingLogo,
    },
    {
      name: 'Underwriting',
      logo: underwritingLogo,
    },
    {
      name: 'Claims',
      logo: claimsLogo,
    },
    {
      name: 'Operations',
      logo: operationsLogo,
    },
  ],
  [
    {
      name: 'Finance & Accounting',
      logo: financeAndAccountingLogo,
    },
    {
      name: 'People and Culture',
      logo: peopleOpsHrLogo,
    },
    {
      name: 'Customer Success',
      logo: customerSuccess,
    },
    {
      name: 'Product & Design',
      logo: productLogo,
    },
    {
      name: 'Engineering',
      logo: engineeringLogo,
    },
  ],
];
export const Teams = () => {
  const { isLg } = useWindowWidth();
  return (
    <div className="container mt-16 mb-20 lg:px-5">
      <h6 className="heading-6 text-primary mb-10 text-center">Different departments at PrishaPolicy</h6>
      <div
        className="grid gap-y-4"
        style={{
          gridTemplateColumns: 'minmax(4,5)',
        }}
      >
        {(isLg ? teams : [teams.flat()]).map((row, idx) => {
          return (
            <div className={`grid gap-x-4 gap-y-4 grid-cols-${isLg ? row.length : 2}`} key={idx}>
              {row.map((team, index) => {
                return <BasicCard title={team.name} image={team.logo} key={team.name} />;
              })}
            </div>
          );
        })}
        {/* {!isLg && <BasicCard title={'Engineering'} image={engineeringLogo} key={'Engineering'} />} */}
      </div>
    </div>
  );
};
